module.exports = __webpack_public_path__ + "img/bg-tranzactii.feca3813.png";